import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SettingsContainer from '../../../components/settings-container';
import BirthdayPicker from '../../../components/birthday-picker';
import UnderAgeWarningModal from '../../../components/modal';
import { calculateAge } from '../../../helpers/birthday';
import { saveBirthday } from '../../../store/ducks/user';
import { openCoppaHelp } from '../../../store/ducks/shared';

import './index.css';

export class BirthdayPickerPage extends Component {
  state = {
    underThirteen: false,
    birthday: this.props.initialValue
  };

  save = async () => {
    try {
      await this.props.saveUserBirthday(this.state.birthday);
    } catch (e) {
      /* do nothing */
    }
  }

  handleUpdate = (valid, birthday) => {
    if (!valid) return;

    const age = calculateAge(birthday);
    const underThirteen = age < 13;

    this.setState({ birthday, underThirteen });
  }

  openCoppaHelp = () => {
    this.props.openCoppaHelp();
  }

  render() {
    return (
      <div className="birthday-picker-page">
        <SettingsContainer
          className="birthday-settings-page"
          pageTitle="What's your birthday?"
          hideSkip={ this.props.appName === 'wolf' }
          isValid={ Boolean(this.state.birthday && !this.state.underThirteen) }
          save={ this.save }
        >
          <BirthdayPicker
            birthday={ this.props.initialValue }
            handleUpdate={ this.handleUpdate }
          />
          { this.state.underThirteen
            ? <UnderAgeWarningModal
              title="Sorry!"
              content="You must be 13 years or older to use iFit. If you entered your birthday incorrectly, click the Help button below."
              primaryActionLabel="Help"
              handlePrimaryActionClick={ this.openCoppaHelp }
              openDefault={ true }
            />
            : null }
        </SettingsContainer>

        <div className="disclaimer">
          <p>
            Your info will be kept private, and only used to personalize your profile. <br />
            You can change it anytime in your settings.
          </p>
        </div>
      </div>
    );
  }
}

BirthdayPickerPage.propTypes = {
  initialValue: PropTypes.string.isRequired,
  saveUserBirthday: PropTypes.func.isRequired,
  appName: PropTypes.string,
  openCoppaHelp: PropTypes.func.isRequired
};

BirthdayPickerPage.defaultProps = {
  initialValue: ''
};

export default connect(
  state => ({
    appName: state.config.appName,
    initialValue: state.user.birthday,
  }),
  dispatch => ({
    saveUserBirthday: birthday => dispatch(saveBirthday(birthday)),
    openCoppaHelp: () => dispatch(openCoppaHelp())
  }),
  null,
  { withRef: true }
)(BirthdayPickerPage);
